import tippy from 'tippy.js';

export function tippyAction(node, params) {
    const instance = tippy(node, params);
    return {
        update(newParams) {
            instance.setProps(newParams);
        },
        destroy() {
            instance.destroy();
        }
    };
}
